const INDEX_ITEMS = [
  { icon: 'ri-star-line', label: '明星八卦', desc: '娱乐圈最新动态追踪', count: '2,380篇' },
  { icon: 'ri-live-line', label: '网红翻车', desc: '直播带货名场面合集', count: '1,850篇' },
  { icon: 'ri-tv-line', label: '综艺实锤', desc: '综艺节目高光与争议', count: '1,620篇' },
  { icon: 'ri-fire-line', label: '社会热点', desc: '时事吃瓜深度解读', count: '2,150篇' },
  { icon: 'ri-spy-line', label: '圈内爆料', desc: '独家内部一手消息', count: '980篇' },
  { icon: 'ri-bar-chart-line', label: '热搜追踪', desc: '实时话题热度跟进', count: '3,420篇' },
  { icon: 'ri-folder-transfer-line', label: '吃瓜合集', desc: '每日精彩内容汇总', count: '5,600篇' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            主题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            七大主题频道，按你的口味挑选最想吃的瓜
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {INDEX_ITEMS.map((item) => (
            <a
              key={item.label}
              href="#cards"
              className="group flex flex-col items-center text-center p-4 md:p-5 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer no-underline border border-background-200/60 hover:border-primary-200"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-semibold text-sm md:text-base text-foreground-800 mb-1 whitespace-nowrap">
                {item.label}
              </h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}